var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9643 9.0595C28.5125 6.77422 27.3618 4.68579 25.6714 3.08303C23.9809 1.48028 21.8342 0.442409 19.5281 0.112969C17.222 -0.216472 14.8705 0.178797 12.7989 1.24411C10.7273 2.30942 9.03783 3.99213 7.96428 6.0595C5.6876 6.32325 3.59732 7.44565 2.11981 9.19773C0.642303 10.9498 -0.111104 13.1996 0.0132727 15.4881C0.137649 17.7766 1.13044 19.9315 2.78913 21.5131C4.44781 23.0948 6.64743 23.984 8.93928 23.9995H28.4393C30.3836 24.0093 32.2552 23.2614 33.6574 21.9144C35.0595 20.5674 35.8819 18.7273 35.9502 16.7842C36.0185 14.8411 35.3273 12.9478 34.0231 11.5057C32.719 10.0637 30.9045 9.18624 28.9643 9.0595V9.0595ZM20.9393 13.4995V19.4995H14.9393V13.4995H10.4393L17.9393 5.9995L25.4393 13.4995H20.9393Z",
    fill: "#486581"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrace);
export default __webpack_public_path__ + "static/media/trace.3b88bb37282d134db051b1885946115b.svg";
export { ForwardRef as ReactComponent };